import { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import MFModal from "../../../common/containers/MFModal";

export const ModalImportXlsx = ({
  isOpen,
  onClose,
  onDrop,
  importErrors,
  hasImportedFdesForm,
  clearFieldsImportErrors,
  closeImportFileModal,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      // "application/vnd.ms-excel": [],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
    },
    multiple: false,
  });

  useEffect(() => {
    clearFieldsImportErrors();
  }, []); // eslint-disable-line

  const handleClose = () => {
    clearFieldsImportErrors();
    onClose();
  };

  useEffect(() => {
    if (closeImportFileModal) {
      handleClose();
    }
  }, [closeImportFileModal]); // eslint-disable-line

  return (
    <MFModal
      isOpen={isOpen}
      onClose={handleClose}
      dialogClassName="modal-import-params"
    >
      {(!hasImportedFdesForm || !importErrors || importErrors.length === 0) && (
        <div
          className={`label-import-file ${isDragActive ? "active" : ""}`}
          {...getRootProps()}
        >
          Cliquez ou glissez-déposez un fichier Excel (.xlsx)
          <br /> pour l'importer
          <input {...getInputProps()} />
        </div>
      )}

      {hasImportedFdesForm && importErrors && importErrors.length > 0 && (
        <div>
          <strong>Erreurs lors de l'importation:</strong>

          <div
            style={{
              maxHeight: "500px",
              overflow: "scroll",
              overflowX: "hidden",
            }}
            className="my-1"
          >
            {importErrors.map((error, index) => (
              <div key={index} className="alert alert-danger">
                <b>
                  Erreur à la ligne {error.line} pour le paramId {error.paramId}
                  :
                </b>

                <br />
                {error.message}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="d-flex justify-content-end align-items-center mt-2">
        {hasImportedFdesForm && importErrors && importErrors.length > 0 && (
          <button
            className="btn btn-primary mr-1"
            onClick={clearFieldsImportErrors}
          >
            Importer à nouveau
          </button>
        )}
        <button className="btn btn-primary outlined" onClick={handleClose}>
          Annuler
        </button>
      </div>
    </MFModal>
  );
};
